import _get from 'lodash.get';
import produce from 'immer';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'toiplusauthor';
const createActionName = name => `toi/${reducerName}/${name}`;

// Actions

export const RECEIVE_INITIAL_AUTHOR_DATA = createActionName(
  'RECEIVE_INITIAL_AUTHOR_DATA',
);
export const RECEIVE_NEXTPAGE_AUTHOR_DATA = createActionName(
  'RECEIVE_NEXTPAGE_AUTHOR_DATA',
);
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');

// Action Creators

function receiveInitialAuthorData(data) {
  return {
    type: RECEIVE_INITIAL_AUTHOR_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveNextPageAuthorData(data, { curpg }) {
  return {
    type: RECEIVE_NEXTPAGE_AUTHOR_DATA,
    payload: {
      ...data,
      curpg,
    },
  };
}

function handleAuthorDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

// Data Gatherers

function fetchAuthorData(params) {
  const curpg = params.curpg || 1;
  const { searchKeyword, isWapView } = params;

  const url = `${getFeedUrl()}/toi/web/show/author?path=/toi-plus/author/${searchKeyword}.cms&curpg=${curpg}`;
  // const url = `http://localhost:3035/feeds/toi/web/show/author?version=v2&path=/toi-plus/author/479245410.cms&rls=true&curpg=${curpg}`;
  return makeRequest.get(url, { isMobile: isWapView });
}

// Exposed Functions

export function loadAuthorData(params) {
  return dispatch =>
    fetchAuthorData(params)
      .then(data => {
        if (params.curpg === 1) {
          dispatch(receiveInitialAuthorData(data.data, params));
        } else {
          dispatch(receiveNextPageAuthorData(data.data, params));
        }
      })
      .catch(error => dispatch(handleAuthorDataError(error)));
}

// Reducer

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_INITIAL_AUTHOR_DATA: {
      const { sections = [] } = action.payload;
      const updatedSections = sections.map(obj => {
        if (obj.tn === 'sectionlisting') {
          obj.items = [...obj.items, { tn: 'separator', curpg: 1 }];
        }
        return obj;
      });
      return {
        ...state,
        ...action.payload,
        sections: updatedSections,
      };
    }

    case RECEIVE_NEXTPAGE_AUTHOR_DATA: {
      const { sections = [], curpg } = action.payload;
      const sectionListing = sections.filter(
        sec => sec.tn === 'sectionlisting',
      );
      const nextState = produce(state, draftState => {
        const sectionData = _get(draftState, 'sections');
        if (
          Array.isArray(sectionData) &&
          sectionData.length &&
          Array.isArray(sectionListing) &&
          sectionListing.length
        ) {
          sectionData.forEach(item => {
            if (item.tn === 'sectionlisting') {
              item.pagination = sectionListing[0].pagination;
              item.items = [
                ...item.items,
                ...sectionListing[0].items,
                { tn: 'separator', curpg },
              ];
            }
          });
        }
      });
      return nextState;
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
